import { useMemo } from 'react';

import { RedeemableTicket } from '@givebacks/api/store';
import { CellContext } from 'core/Hooks';
import { Group, Stack, Text } from 'ui';
import { IconCircleCheck } from 'ui/Icons';

type CellContextProps = CellContext<RedeemableTicket, string>;

const CheckInStatusColumn = ({ row }: CellContextProps) => {
  const isUsed = useMemo(() => row.original.fulfilled_at, [row.original.fulfilled_at]);
  const isRefunded = useMemo(() => !!row.original.deleted_at, [row.original.deleted_at]);

  if (isRefunded) {
    return <span>Refunded</span>;
  }

  if (isUsed) {
    return (
      <Group gap={4} c="mint.7" wrap="nowrap">
        <IconCircleCheck size={16} />
        <Text fz="xs" fw={600} style={{ whiteSpace: 'nowrap' }}>
          Checked-in
        </Text>
      </Group>
    );
  }

  return <span>Unused</span>;
};

const TicketHolderNameColumn = ({ row, getValue }: CellContextProps) => {
  return (
    <Stack gap={0}>
      <Text type="caption" c="gray">
        {getValue()} {row.original.last_name}
      </Text>
      <Text fz={'xxxs'}>{row.original?.email}</Text>
    </Stack>
  );
};

export { CheckInStatusColumn, TicketHolderNameColumn };
